module.exports = __webpack_public_path__ + "static/media/company.f19acfd9.svg";